import {
  Box,
  Divider,
  Grid,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const steps = [
  {
    label: "Type Of Institution",
  },
  {
    label: "Institution Details",
  },
  {
    label: "Contact Details",
  },
  {
    label: "Investment Planning",
  },
  {
    label: "Review",
  },
];

const Index = () => {
  const dimension = useSelector((store) => store.dimension);
  const mode = useSelector((store) => store.mode.mode);
  let location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const navigate = useNavigate();
  let { id } = useParams();

  React.useEffect(() => {
    if (location.pathname == "/institution-create/type-of-investor") {
      setActiveStep(0);
    } else if (
      location.pathname == `/institution-create/institution-details/${id}`
    ) {
      setActiveStep(1);
    } else if (
      location.pathname == `/institution-create/contact-details/${id}`
    ) {
      setActiveStep(2);
    } else if (
      location.pathname == `/institution-create/investment-planning/${id}`
    ) {
      setActiveStep(3);
    } else if (location.pathname == `/institution-create/review/${id}`) {
      setActiveStep(4);
    }
  }, [location]);

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  return (
    <React.Fragment>
      {dimension.width > 600 ? (
        <Grid
          p={5}
          container
          spacing={1}
          className={mode ? "dark-bg-1" : "light-bg-"}
          mt={10}
          alignContent="center"
        >
          <Grid item xs={2} alignItems="center">
            <Stack direction="row" gap={4}>
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              {/* <Divider orientation="vertical" flexItem /> */}
            </Stack>
          </Grid>

          <Grid item xs={10}>
            <Outlet />
          </Grid>
        </Grid>
      ) : (
        <React.Fragment>
          <Typography
            color="secondary"
            onClick={() => {
              navigate(-1);
            }}
            sx={{
              mt: 2,
            }}
          >
            <ArrowBackIcon />
          </Typography>

          <Box mt={2}>
            <Stepper activeStep={activeStep} orientation="horizontal">
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel>{""}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
          <Box mt={2}>
            <Outlet />
          </Box>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Index;
